import React from "react";
import {connect} from 'dva';
import {Descriptions} from 'antd';
import {framework_tool, component_tool, utils_tool} from '@/tool'
import createColumns from './columns'

let {WizContainer, modelUtils} = framework_tool
let {WizCard, WizSpin, WizButton, WizSearchBar, WizDataTable, WizBrowserExport, WizTabs,} = component_tool
let {Session, getPageData} = utils_tool


const getDetailRecord = (history) => {
  let pathname = history.location.pathname;

  let detailInfo = ''
  const sessionName = pathname.split('/').filter(item => !!item).join('-') + '-Record'
  if (history?.location?.record) {
    detailInfo = history.location.record || {}
    Session.add(sessionName, detailInfo)
  } else {
    detailInfo = Session.get(sessionName) || {}
  }
  return detailInfo
}

class ContentRecord extends WizContainer {
  componentName = 'contentRecord'

  constructor(props) {
    super(props)

    let detailInfo = getDetailRecord(props.history);
    this.detailInfo = detailInfo
    this.visitFilters = {}
    this.chooseFilters = {}
    this.state = {
      notesId: detailInfo.id,
      operationType: 1,
      favoritesCount: 0,
      likeCount: 0,
      readCount: 0,
      downloadCount: 0
    }
    this.bizType = 55;
  }

  _componentDidMount() {
    this._getFavoritesList();
    this._getLikeList()
    this._getReadList();
    this._getDownloadList();
  }

  propsAndStateOnChange = {
    favoritesPageList: this._favoritesList.bind(this),
    favoritesExport: this._favoritesExportOver.bind(this),
    likeExport: this._likeExportOver.bind(this),
    likePageList: this._likePageList.bind(this),
    recordExport: this._exportOver.bind(this),
    readPageList: this._readPageList.bind(this),
    downloadPageList: this._downloadPageList.bind(this)
  }


  /**
   * record download count
   * @param {*} nextProps
   * @param {*} nextState
   */
  _downloadPageList(nextProps, nextState) {
    let {downloadPageList} = nextProps
    if (downloadPageList['success']) {
      nextState['downloadCount'] = downloadPageList?.['data']?.['total'] || 0
    }
    return true
  }


  /**
   * record read count
   * @param {*} nextProps
   * @param {*} nextState
   */
  _readPageList(nextProps, nextState) {
    let {readPageList} = nextProps
    if (readPageList['success']) {
      nextState['readCount'] = readPageList?.['data']?.['total'] || 0
    }
    return true
  }

  /**导出记录*/
  _exportOver(nextProps, nextState) {
    let columnDefs = [
      {
        headerName: '',
        width: 30,
        field: 'rowIndex',
        hidden: true,
        suppressMovable: true,
        cellStyle: {
          textAlign: 'center',
          padding: '5px 0',
          color: '#595959',
          backgroundColor: '#f0f0f0',
          display: 'inline-flex',
          alignItems: 'center',
          justifyContent: 'center',
          fontWeight: '500',
          boxShadow: '0 2px 0px 0 rgba(0,0,0,0.15)'
        }
      },
      {
        headerName: '账号',
        field: 'userName',
        width: 20,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: {vertical: 'bottom', horizontal: 'left'},
        },
      },
      {
        headerName: '姓名',
        field: 'fullName',
        width: 20,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: {vertical: 'bottom', horizontal: 'left'},
        },
      },
      {
        headerName: '任职',
        field: 'userIdentityInfos',
        width: 40,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: {vertical: 'bottom', horizontal: 'left'},
        },
      },
      {
        headerName: `${nextState['operationType'] ? '阅读时间' : '下载时间'}`,
        field: 'operationTime',
        width: 20,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: {vertical: 'bottom', horizontal: 'left'},
        },
      },
    ]
    const getIdentityInfo = (identity) => identity && Object.keys(identity).length ? `${identity.orgName} - ${identity.positionName}` : ''
    if (nextProps.recordExport.code === 1) {
      let data = nextProps.recordExport.data

      data.forEach((val, index) => {
        val['userIdentityInfos'] = val['identityList']?.map(item => getIdentityInfo(item)).join(',')
      })

      WizBrowserExport({
        title: `${nextState['operationType'] ? '阅读' : '下载'}记录信息`,
        sheetName: `${nextState['operationType'] ? '阅读' : '下载'}记录信息`,
        columns: columnDefs.filter((_, index) => index),
        rows: data,
        filename: `${nextState['operationType'] ? '阅读' : '下载'}记录信息.xlsx`,
      })
      return true;
    } else {
      wizNotice.error('获取导出数据失败')
      return false;
    }
  }
  _favoritesExportOver(nextProps, nextState) {
    let {success, data} = nextProps.favoritesExport
    if (success) {
      let columnDefs = [
        {
          headerName: '',
          width: 30,
          field: 'rowIndex',
          hidden: true,
          suppressMovable: true,
          cellStyle: {
            textAlign: 'center',
            padding: '5px 0',
            color: '#595959',
            backgroundColor: '#f0f0f0',
            display: 'inline-flex',
            alignItems: 'center',
            justifyContent: 'center',
            fontWeight: '500',
            boxShadow: '0 2px 0px 0 rgba(0,0,0,0.15)'
          }
        },
        {
          headerName: '账号',
          field: 'userName',
          width: 20,
          cellStyle: {
            textAlign: 'center',
          },
          style: {
            alignment: {vertical: 'bottom', horizontal: 'left'},
          },
        },
        {
          headerName: '姓名',
          field: 'fullName',
          width: 20,
          cellStyle: {
            textAlign: 'center',
          },
          style: {
            alignment: {vertical: 'bottom', horizontal: 'left'},
          },
        },
        {
          headerName: '任职',
          field: 'identityInfos',
          width: 40,
          cellStyle: {
            textAlign: 'center',
          },
          style: {
            alignment: {vertical: 'bottom', horizontal: 'left'},
          },
        },
        {
          headerName: '收藏时间',
          field: 'favoritesTime',
          width: 20,
          cellStyle: {
            textAlign: 'center',
          },
          style: {
            alignment: {vertical: 'bottom', horizontal: 'left'},
          },
        },
      ]
      const getIdentityInfo = (identity) => identity && Object.keys(identity).length ? `${identity.orgName} - ${identity.positionName}` : ''

      data.forEach((val, index) => {
        val['identityInfos'] = val['identityList']?.map(item => getIdentityInfo(item)).join(',')
      })

      WizBrowserExport({
        title: `收藏记录信息`,
        sheetName: `收藏记录信息`,
        columns: columnDefs.filter((_, index) => index),
        rows: data,
        filename: `收藏记录信息.xlsx`,
      })
      return true;
    } else {
      wizNotice.error('获取导出数据失败')
      return false;
    }
  }
  _likeExportOver(nextProps, nextState) {
    let {success, data} = nextProps.likeExport
    if (success) {
      let columnDefs = [
        {
          headerName: '',
          width: 30,
          field: 'rowIndex',
          hidden: true,
          suppressMovable: true,
          cellStyle: {
            textAlign: 'center',
            padding: '5px 0',
            color: '#595959',
            backgroundColor: '#f0f0f0',
            display: 'inline-flex',
            alignItems: 'center',
            justifyContent: 'center',
            fontWeight: '500',
            boxShadow: '0 2px 0px 0 rgba(0,0,0,0.15)'
          }
        },
        {
          headerName: '账号',
          field: 'userName',
          width: 20,
          cellStyle: {
            textAlign: 'center',
          },
          style: {
            alignment: {vertical: 'bottom', horizontal: 'left'},
          },
        },
        {
          headerName: '姓名',
          field: 'fullName',
          width: 20,
          cellStyle: {
            textAlign: 'center',
          },
          style: {
            alignment: {vertical: 'bottom', horizontal: 'left'},
          },
        },
        {
          headerName: '任职',
          field: 'identityInfos',
          width: 40,
          cellStyle: {
            textAlign: 'center',
          },
          style: {
            alignment: {vertical: 'bottom', horizontal: 'left'},
          },
        },
        {
          headerName: '点赞时间',
          field: 'operateTime',
          width: 20,
          cellStyle: {
            textAlign: 'center',
          },
          style: {
            alignment: {vertical: 'bottom', horizontal: 'left'},
          },
        },
      ]
      const getIdentityInfo = (identity) => identity && Object.keys(identity).length ? `${identity.orgName} - ${identity.positionName}` : ''

      data.forEach((val, index) => {
        val['identityInfos'] = val['identityList']?.map(item => getIdentityInfo(item)).join(',')
      })

      WizBrowserExport({
        title: `点赞记录信息`,
        sheetName: `点赞记录信息`,
        columns: columnDefs.filter((_, index) => index),
        rows: data,
        filename: `点赞记录信息.xlsx`,
      })
      return true;
    } else {
      wizNotice.error('获取导出数据失败')
      return false;
    }
  }

  _getFavoritesList(apiParams = {}) {
    let {notesId} = this.state
    this.doAction({
      path: 'favorites/list',
      payload: {
        key: 'favorites@favoritesPageList',
        apiParams: {
          bizType: this.bizType,
          bizId: notesId,
          ...apiParams
        }
      }
    })
  }
  _getFavoritesInfo(apiParams = {}) {
    let {notesId} = this.state
    this.doAction({
      path: 'favorites/export',
      payload: {
        key: 'favorites@favoritesList',
        apiParams: {
          bizType: this.bizType,
          bizId: notesId,
          ...apiParams
        }
      }
    })
  }

  _favoritesList(nextProps, nextState) {
    let {favoritesPageList} = nextProps
    if (favoritesPageList['success']) {
      nextState['favoritesCount'] = favoritesPageList?.['data']?.['total'] || 0
    }
    return true
  }

  _getLikeList(apiParams = {}) {
    let {notesId} = this.state
    this.doAction({
      path: 'operateRecord/operateRecordUserPageList',
      payload: {
        key: 'operateRecord@likePageList',
        apiParams: {
          bizType: this.bizType,
          bizId: notesId,
          operateType: 1,
          ...apiParams
        }
      }
    })
  }

  _getLikeInfo(apiParams = {}) {
    let {notesId} = this.state
    this.doAction({
      path: 'operateRecord/operateRecordUserList',
      payload: {
        key: 'operateRecord@likeList',
        apiParams: {
          bizType: this.bizType,
          bizId: notesId,
          operateType: 1,
          ...apiParams
        }
      }
    })
  }

  _likePageList(nextProps, nextState) {
    let {likePageList} = nextProps
    if (likePageList['success']) {
      nextState['likeCount'] = likePageList?.['data']?.['total'] || 0
    }
    return true
  }

  _getReadList(apiParams = {}) {
    let {notesId} = this.state
    this.doAction({
      path: 'notesRecord/list',
      payload: {
        key: 'notesRecord@readPageList',
        apiParams: {
          notesId: notesId,
          operationType: 1,
          ...apiParams
        }
      }
    })
    this.setState({
      operationType: 1
    })
  }

  _getReadInfo(apiParams = {}) {
    let {notesId} = this.state
    this.doAction({
      path: 'notesRecord/export',
      payload: {
        key: 'notesRecord@recordList',
        apiParams: {
          notesId: notesId,
          operationType: 1,
          ...apiParams
        }
      }
    })

    this.setState({
      operationType: 1
    })
  }

  _onSelect(keys, rows) {
    this.setState({
      keys,
      rows,
      selectedRows: keys.length
    })
  }

  _getDownloadList(apiParams = {}) {
    let {notesId} = this.state
    this.doAction({
      path: 'notesRecord/list',
      payload: {
        key: 'notesRecord@downloadPageList',
        apiParams: {
          notesId: notesId,
          operationType: 0,
          ...apiParams
        }
      }
    })

    this.setState({
      operationType: 0
    })
  }

  _getDownloadInfo(apiParams = {}) {
    let {notesId} = this.state
    this.doAction({
      path: 'notesRecord/export',
      payload: {
        key: 'notesRecord@recordList',
        apiParams: {
          notesId: notesId,
          operationType: 0,
          ...apiParams
        }
      }
    })
  }

  /**
   * 渲染操作按钮 且 进行权限检查
   */
  _renderBtn = (type) => {
    let r = []
    let btns = new Map();
    btns.set('export',
      <WizButton title="导出"
                 type="export"
                 onClick={() => {
                   let action = {
                     favorites: () => this._getFavoritesInfo(this.favoritesFilters),
                     like: () => this._getLikeInfo(this.likeFilters),
                     read: () => this._getReadInfo(this.visitFilters),
                     download: () => this._getDownloadInfo(this.chooseFilters),
                   }
                   action?.[type]?.()
                 }}
                 icon="export"
                 style={{marginBottom: 15}}>导出</WizButton>);
    let btnCode = this.getMenuBtn() || [];
    btnCode.map(({code}) => {
      if (btns.has(code)) {
        r.push(btns.get(code))
      }
    })
    return r
  }


  renderRecordInfo = (type) => {
    let {favoritesPageList, likePageList, readPageList, downloadPageList, loading} = this.props
    let columns = createColumns(this, type)
    let pageList = {
      favorites: favoritesPageList,
      like: likePageList,
      read: readPageList,
      download: downloadPageList,
    }[type];

    let list = getPageData(pageList && pageList.data)
    let searchBarProps = {
      columns,
      onSearch: values => {
        if (type === 'favorites') {
          this.favoritesFilters = values
          this._getFavoritesList(values)
        }
        if (type === 'like') {
          this.likeFilters = values
          this._getLikeList(values)
        }
        if (type === 'read') {
          this.visitFilters = values
          this._getReadList(values)
        }
        if (type === 'download') {
          this.chooseFilters = values
          this._getDownloadList(values)
        }
      }
    }
    let dataTableProps = {
      loading: loading,
      columns,
      rowKey: 'id',
      dataItems: list,
      isScroll: true,
      onChange: ({pageNum, pageSize}) => {
        let action = {
          favorites: () => this._getFavoritesList({current: pageNum, size: pageSize, ...this.favoritesFilters}),
          like: () => this._getLikeList({current: pageNum, size: pageSize, ...this.likeFilters}),
          read: () =>  this._getReadList({current: pageNum, size: pageSize, ...this.visitFilters}),
          download: () => this._getDownloadList({current: pageNum, size: pageSize, ...this.chooseFilters}),
        }

        action?.[type]?.()
      },
      onSelect: (keys, rows) => this._onSelect(keys, rows)
    }
    return (
      <WizSpin tip={'加载中'} spinning={loading}>
        <div className='pagination'>
          <WizSearchBar key="contentRecord_searchBar" type="grid" {...searchBarProps} />
        </div>
        {this._renderBtn(type)}
        <WizDataTable key={'contentRecord_dataTable'} {...dataTableProps} />
        <div className='pagination'>
          <WizDataTable.Pagination key={'contentRecord_pagination'} {...dataTableProps} />
        </div>
      </WizSpin>
    )
  }

  _render() {
    const items = this.detailInfo
    let {favoritesCount, likeCount, readCount, downloadCount} = this.state

    let recordTable = []

    recordTable.push({
      init: this._getFavoritesList.bind(this, this.favoritesFilters),
      view: <WizTabs.TabPane tab={`收藏记录(${favoritesCount})`} key={(recordTable.length + 1).toString()}>{this.renderRecordInfo('favorites')}</WizTabs.TabPane>,
    })
    recordTable.push({
      init: this._getLikeList.bind(this, this.likeFilters),
      view: <WizTabs.TabPane tab={`点赞记录(${likeCount})`} key={(recordTable.length + 1).toString()}>{this.renderRecordInfo('like')}</WizTabs.TabPane>,
    })
    recordTable.push({
      init: this._getReadList.bind(this, this.visitFilters),
      view: <WizTabs.TabPane tab={`阅读记录(${readCount})`} key={(recordTable.length + 1).toString()}>{this.renderRecordInfo('read')}</WizTabs.TabPane>,
    })

    return (
      <React.Fragment>
        <WizCard title={'基础信息'}>
          <Descriptions column={2} style={{paddingLeft: 25}}>
            <Descriptions.Item label='标题'>{items.title}</Descriptions.Item>
            <Descriptions.Item label='是否公开'>{{0: '否', 1: '是'}[items.isPublic] || items.isPublic}</Descriptions.Item>
            <Descriptions.Item label='作者'>{items.fullName}</Descriptions.Item>
            <Descriptions.Item label='更新时间'>{items.lastUpdateTime}</Descriptions.Item>
          </Descriptions>
        </WizCard>

        <WizCard title="记录管理">
          <WizTabs defaultActiveKey="1" onChange={(e) => recordTable[parseInt(e) - 1].init()}>
            {recordTable.map(({view}) => view)}
          </WizTabs>
        </WizCard>
      </React.Fragment>
    )
  }
}

const mapStateToProps = (state, ownProps) => {
  let {notesRecord, favorites, operateRecord} = state
  const favoritesPageList = modelUtils.getModelEntity(favorites, 'favorites@favoritesPageList');
  const favoritesList = modelUtils.getModelEntity(favorites, 'favorites@favoritesList');
  const likePageList = modelUtils.getModelEntity(operateRecord, 'operateRecord@likePageList');
  const likeList = modelUtils.getModelEntity(operateRecord, 'operateRecord@likeList');
  const readPageList = modelUtils.getModelEntity(notesRecord, 'notesRecord@readPageList');
  const downloadPageList = modelUtils.getModelEntity(notesRecord, 'notesRecord@downloadPageList');
  const recordExport = modelUtils.getModelEntity(notesRecord, 'notesRecord@recordList');
  const {notesRecordLoading: notesLoad} = modelUtils.getLoadingState(state, 'notesRecord')
  const {favoritesLoading: favoritesLoad} = modelUtils.getLoadingState(state, 'favorites')
  const {operateRecordLoading: likeLoad} = modelUtils.getLoadingState(state, 'operateRecord')

  return {
    favoritesPageList,
    favoritesExport: favoritesList,
    likePageList,
    likeExport: likeList,
    readPageList,
    downloadPageList,
    recordExport,
    loading: notesLoad || favoritesLoad || likeLoad
  }
};

export default connect(mapStateToProps)(ContentRecord)
